import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { Table } from '../../../iba-components/Table'
import { showPopBanner } from '../../../iba-components/PopBanner'
import { Loading } from '../../components/Loading'
import { EditThemeModal } from '../../components/EditThemeModal'
import ConfirmModal from '../../components/ConfirmModal'
import { fetchBaseThemes, deleteBaseThemeMap } from '../../api/theme'
import { getColumnList } from './tableColumns'
import './baseTheme.css'

export const BASE_THEME_TYPE = 'base'
export const FAILED_STATUS = '2'

export const BaseTheme = () => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [listData, setListData] = useState([])
    const [id, setId] = useState()
    const [themeDetailData, setThemeDetailData] = useState()
    const [showModal, setShowModal] = useState(false)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [idToDelete, setIdToDelete] = useState()

    const deleteConfirm = (e, props) => {
        e.stopPropagation()
        setIdToDelete({
            id: props.id,
            name: props.name
        })
        setShowDeleteConfirm(true)
    }

    const generateErrorMsg = (list) => {
        let clientThemes = ``
        if (list && !!list.length) {
            list.forEach((it, index) => {
                if (index === list.length - 1) {
                    clientThemes = `${clientThemes}「${it.name}」 `
                } else {
                    clientThemes = `${clientThemes}「${it.name}」、`
                }
            })
        }
        return (
            <div>
                <div>{t(`theme.warningMsg.optError`)}</div>
                {clientThemes && (
                    <div>
                        {t(`theme.warningMsg.baseThemeDeleteError`, {
                            baseThemeName: idToDelete.name,
                            clientThemes
                        })}
                    </div>
                )}
            </div>
        )
    }

    const handleDeleteTheme = async () => {
        if (idToDelete) {
            setShowDeleteConfirm(false)
            setLoading(true)
            const res = await deleteBaseThemeMap({ id: idToDelete.id })
            setLoading(false)
            if (res) {
                if (res.hasError && res.status === FAILED_STATUS) {
                    showPopBanner({
                        message: generateErrorMsg(res.clients),
                        status: 'error',
                        duration: 10000
                    })
                } else {
                    fetchData()
                    setIdToDelete()
                    showPopBanner({
                        message: t(`theme.warningMsg.optSuccess`),
                        status: 'success',
                        duration: 2000
                    })
                }
            }
        }
    }

    const handleNew = () => {
        setId(null)
        setThemeDetailData(null)
        setShowModal(true)
    }

    const handleTrClick = (original) => {
        setId(original.id)
        setThemeDetailData(original)
        setShowModal(true)
    }

    const handleModalCancel = () => {
        setShowModal(false)
    }

    const handleSaveCallback = () => {
        fetchData()
    }

    const fetchData = async () => {
        setLoading(true)
        const res = await fetchBaseThemes()
        setLoading(false)
        if (res) {
            setListData(res.data)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <div className="themeContainer">
                <div className="header">
                    <div className="flex-middle flex-between">
                        <div className="title">{t('theme.baseTheme.title')}</div>
                        <Button width="96px" label={t('systemInfoManagement.new')} onClick={handleNew} />
                    </div>
                </div>
                <Loading visible={loading}>
                    <Table
                        data={listData}
                        columns={getColumnList(t, deleteConfirm)}
                        handleClickRow={handleTrClick}
                        sort={[
                            {
                                id: 'created_date',
                                desc: true
                            }
                        ]}
                        isBottomPagination={false}
                        isDownload={false}
                    />
                </Loading>
            </div>
            {showModal && (
                <EditThemeModal
                    showModal={showModal}
                    title={id ? t('theme.modal.baseTheme.editTitle') : t('theme.modal.baseTheme.addTitle')}
                    id={id}
                    themeName={themeDetailData?.name}
                    selectedItems={themeDetailData?.theme_id}
                    handleCancel={handleModalCancel}
                    handleSaveCallback={handleSaveCallback}
                    type={BASE_THEME_TYPE}
                    keyField="themeid"
                />
            )}
            {showDeleteConfirm && (
                <ConfirmModal
                    visible={showDeleteConfirm}
                    content={t('theme.warningMsg.deleteConfirm', {
                        name: idToDelete.name
                    })}
                    onCancel={() => setShowDeleteConfirm(false)}
                    onSubmit={handleDeleteTheme}
                />
            )}
        </>
    )
}
